import { useUserQuery } from 'api/user/queries'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from 'components/DropdownMenu'
import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useHasAdminAccess } from 'hooks/useHasAdminAccess'

import { getConfiguration } from 'services/config'

import { GoToAdmin } from './GoToAdmin'
import { GoToFlowMarketing } from './GoToFlowMarketing'
import { GoToPlatform } from './GoToPlatform'
import { LanguageSelector } from './LanguageSelector'
import { Logout } from './Logout'
import { RedirectToLogin } from './RedirectToLogin'
import { ResetOnboarding } from './ResetOnboarding'
import { ThemeSelector } from './ThemeSelector'
import { UserMenuInitials } from './UserMenuInitials'

export const UserMenu = () => {
  const { data: username } = useUserQuery({
    select: ({ user: { name } }) => name,
  })

  const hasAdminAccess = useHasAdminAccess()

  const hasMultiLanguageFeatureFlag = useFeatureFlag('multi_languages')

  const { hasGoToPlatform } = getConfiguration()

  if (!username) return

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <UserMenuInitials username={username} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="mr-4 w-72 lg:w-56 xl:w-64 2xl:w-72">
        <RedirectToLogin username={username} />
        {hasGoToPlatform && <GoToPlatform />}
        <GoToFlowMarketing />
        <ThemeSelector />
        {hasMultiLanguageFeatureFlag && <LanguageSelector />}
        {hasAdminAccess && <GoToAdmin />}
        {hasAdminAccess && <ResetOnboarding />}
        <Logout />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
